import React from 'react';
import { useI18n } from '../i18n/I18nContext';
import './MirrorRooms.css';

const rooms = [
  {
    id: 'einszueins',
    title: '1:1 Spiegel-Arbeit',
    edge: 'cta',
    subtitle:
      'Für Entscheiderinnen und Entscheider vor und in entscheidenden Momenten',
    body: 'Eine Verhandlung, die über Jahre entscheidet. Ein Team, das Ihre Führung nicht trägt. Ein Rollenwechsel, der mehr verlangt als Erfahrung. In der Einzelarbeit erkennen Sie, welche Muster Sie tragen und welche Sie behindern, und bereiten den entscheidenden Schritt präzise vor.',
    occasions: [
      'Verhandlungen und Gespräche mit hohem Einsatz',
      'Führung gegen Widerstand',
      'Rollenwechsel, Nachfolge und neue Verantwortung',
    ],
    format:
      'Online oder in Präsenz. Der Umfang richtet sich nach dem Anliegen, nicht nach der Uhr.',
  },
  {
    id: 'systeme',
    title: 'Spiegelkraft für Systeme',
    edge: 'mirror',
    subtitle: 'Für Führungskreise, Projektteams und Familienunternehmen',
    body: 'Wenn ein System sich festgefahren hat, liegt das Problem selten bei einer einzelnen Person. In Workshops und Mediationen wird sichtbar, wie Ihr System tatsächlich funktioniert und wo es sich bewegen lässt.',
    occasions: [
      'Konflikte im Führungskreis oder in der Projektleitung, als Mediation',
      'Macht, Rollen und Erwartungen im Familienunternehmen',
      'Verhandlungsführung sowie Feedback- und Konfliktkultur, als Workshop',
    ],
    format: 'Halb- oder ganztägig, inhouse oder an einem neutralen Ort.',
  },
  {
    id: 'zirkel',
    title: 'Spiegel für Wirkung und Haltung',
    edge: 'heading',
    subtitle: 'Für Führungskräfte und Talente auf dem Weg ins Top-Management',
    body: 'Auf oberster Ebene entscheidet selten die fachliche Leistung allein, sondern Präsenz und informelle Macht. In der Einzelarbeit erkennen Sie, wie Sie dort wirken, wo die Grenzen verlaufen, die Sie halten sollten, und was es braucht, um dort zu bestehen.',
    occasions: [
      'Präsenz und Positionierung vor Vorstand und Top-Management',
      'Informelle Macht und ungeschriebene Spielregeln',
      'Loyalitätskonflikte zwischen Zielvorgabe, Compliance und Haltung',
    ],
    format:
      'Online oder in Präsenz. Auf Wunsch als Programm für mehrere Führungskräfte eines Unternehmens, stets in Einzelarbeit.',
  },
];

function MirrorRooms() {
  const { lang, copy } = useI18n();
  const items = lang === 'en' ? copy.rooms : rooms;

  return (
    <section
      id="raeume"
      className="michaela-mirror-rooms"
      aria-label={copy.home.roomsAria}
    >
      <div className="michaela-mirror-rooms-inner">
        <h2 className="michaela-mirror-rooms-heading mirror-ornament">
          {copy.home.roomsHeading}
        </h2>
        <p className="michaela-mirror-rooms-intro">
          {copy.home.roomsIntro}
        </p>
        <div className="michaela-mirror-rooms-grid">
          {items.map((room) => (
            <article
              key={room.id}
              className={`michaela-mirror-room michaela-mirror-room--${room.edge}`}
            >
              <h3 className="michaela-mirror-room-title">{room.title}</h3>
              {room.subtitle && (
                <p className="michaela-mirror-room-subtitle">{room.subtitle}</p>
              )}
              {room.note && (
                <p className="michaela-mirror-room-note">{room.note}</p>
              )}
              <p className="michaela-mirror-room-body">{room.body}</p>
              {room.occasions && (
                <ul className="michaela-mirror-room-topics">
                  {room.occasions.map((occasion) => (
                    <li key={occasion}>{occasion}</li>
                  ))}
                </ul>
              )}
              {room.format && (
                <p className="michaela-mirror-room-format">
                  <strong>{copy.home.formatLabel}</strong> {room.format}
                </p>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MirrorRooms;
